import { Navigate, Route, Routes } from 'react-router-dom';
import { routerPaths } from '@ax/constants';
import PrivateRoute from './PrivateRoute';
import Login from '@/pages/Login';
import DuplicateTab from '@/pages/DuplicateTab';
import ResetPassword from '@/pages/ResetPassword';
import ForgotPassword from '@/pages/ForgotPassword';
import SupportPage from '@/pages/Support';
import Settings from '@/pages/Settings';
import Notes from '@/pages/Notes';
import AdminNote from '@/pages/AdminNote';
import AdminRoute from '@/components/AdminRoute/AdminRoute.tsx';
import AdminNoteConnected from '@/pages/AdminNoteConnected';

const ProjectRouters = () => {
  return (
    <Routes>
      <Route
        path={routerPaths.root}
        element={
          <Navigate
            to={routerPaths.login}
            replace
          />
        }
      />
      <Route
        path={routerPaths.ssoSuccess}
        element={<Login />}
      />
      <Route
        path={routerPaths.login}
        element={<Login />}
      />
      <Route element={<PrivateRoute />}>
        <Route
          path={routerPaths.duplicateTab}
          element={<DuplicateTab />}
        />
        <Route
          path={routerPaths.resetPassword}
          element={<ResetPassword />}
        />
        <Route
          path={routerPaths.notes}
          element={<Notes />}
        />
        <Route
          path={routerPaths.settings}
          element={<Settings />}
        />
      </Route>
      <Route element={<AdminRoute />}>
        <Route
          path={routerPaths.adminNotes}
          element={<AdminNote />}
        />
        <Route
          path={routerPaths.connectedNotes}
          element={<AdminNoteConnected />}
        />
      </Route>
      <Route
        path={routerPaths.forgotPassword}
        element={<ForgotPassword />}
      />
      <Route
        path={routerPaths.support}
        element={<SupportPage />}
      />
      <Route
        path="*"
        element={
          <Navigate
            to={routerPaths.login}
            replace
          />
        }
      />
    </Routes>
  );
};

export default ProjectRouters;
